// src/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reportsPageNumber: 0,
  reportPageNumber: 0,
  dashBoardPageNumber: 0,
  reportSearchValue: "",
  dashboardPageNumber: 0,

  dashboardSearchValue: "",
  dashBoardTabVal: 0,
  selectBoxInReport: "",
  fileType: 0,
  selectedFileReports: [],
  selectedFileFormatId: null,
};
export const searchPaginationSlice = createSlice({
  name: "searchPaginationSlice",
  initialState: initialState,
  reducers: {
    setReportsPageNumber: (state, { payload }) => {
      state.reportsPageNumber = payload;
    },
    setReportPageNumber: (state, { payload }) => {
      state.reportPageNumber = payload;
    },
    setReportSearchValue: (state, { payload }) => {
      state.reportSearchValue = payload;
    },
    setDashBoardPageNumber: (state, { payload }) => {
      state.dashBoardPageNumber = payload;
    },

    clearsearchPaginationSlice: () => {
      return initialState;
    },
    setDashboardPageNumber: (state, { payload }) => {
      state.dashboardPageNumber = payload;
    },
    setDashboardSearchValue: (state, { payload }) => {
      state.dashboardSearchValue = payload;
    },
    setDashBoardTabVal: (state, { payload }) => {
      state.dashBoardTabVal = payload;
    },
    setSelectBoxInReport: (state, { payload }) => {
      state.selectBoxInReport = payload;
    },
    setFileType: (state, { payload }) => {
      state.fileType = payload;
    },
    setSelectedFileReports: (state, { payload }) => {
      state.selectedFileReports = payload;
    },
    setSelectedFileFormatId: (state, { payload }) => {
      state.selectedFileFormatId = payload;
    },
    setFilesPartsEmpty: (state, { payload }) => {
      state.fileType = 0;

      state.selectedFileReports = [];
      state.selectedFileFormatId = null;
    },
  },
});

export const {
  increment,
  decrement,
  setReportsPageNumber,
  clearsearchPaginationSlice,
  setReportPageNumber,
  setReportSearchValue,
  setDashBoardPageNumber,
  setDashboardPageNumber,
  setDashBoardTabVal,
  setDashboardSearchValue,
  setSelectBoxInReport,

  setFileType,
  setSelectedFileReports,
  setSelectedFileFormatId,
  setFilesPartsEmpty,
} = searchPaginationSlice.actions;

export default searchPaginationSlice.reducer;
